export default __webpack_public_path__ + "images/0x4515a45337f461a11ff0fe8abf3c606ae5dc00c9.png";